import React from "react";
import BarVeriticalSonndesfro from "../Charts/BarVeriticalSonndesfro";
import CoalitionBuilder from "./CoalitionBuilder";

const Sonndesfro = ({ t, data }) => {
  const { partyName, sonndesfro, sonndesfroParty } = data;
  return (
    <div className="px-0 bg-white pt-10" id="sonndesfro">
      <span className="text-22 font-medium uppercase block md:hidden">
        {t("sonndesfro")}
      </span>
      <span className="font-medium text-32 hidden md:inline">
        {t("sonndesfro")}
      </span>

      <div className="h-[1px] bg-black bg-opacity-40 mb-7"></div>

      <div className="flex flex-col md:grid md:grid-cols-2 md:gap-10">
        <div className="chart-box">
          <div className="flex flex-col">
            <span className="text-lg font-medium leading-6">
              {t("polls") + " " + partyName}
            </span>
            <span className="leading-[17px]">{t("inPercentage")}</span>
          </div>
          <div className="h-[250px] lg:h-[250px] pt-3">
            <BarVeriticalSonndesfro
              data={sonndesfro}
              className="h-full"
              t={t}
            />
          </div>
          <span className="text-xs text-black/70 mt-5">{t("sourceTwo")}</span>
        </div>
        <CoalitionBuilder
          data={sonndesfroParty}
          t={t}
          currentParty={partyName}
        />
      </div>
    </div>
  );
};

export default Sonndesfro;
